<template>
  <div class="tw-relative">
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
      <cl-icon-empty-ufo />
      <div class="tw-flex tw-flex-col tw-gap-2 tw-text-center">
        <div class="tw-font-medium tw-text-xl">
          {{ $t("sys-error-default") }}
        </div>
        <div class="tw-text-sm">
          {{ $t("subtext-sys-error-default") }}
        </div>
      </div>
    </div>
  </div>
</template>
